const SCRIPT_SRC = 'https://accounts.google.com/gsi/client'

// Google Identity Services, only the parts the sign-in button uses.
export interface GoogleCredentialResponse {
	credential?: string
}

export interface GoogleIdentityServices {
	accounts: {
		id: {
			initialize: (config: { client_id: string; callback: (response: GoogleCredentialResponse) => void }) => void
			renderButton: (parent: HTMLElement, options: Record<string, unknown>) => void
		}
	}
}

// `window.google` is also the Maps namespace, so it is read through its own type rather than merged into Window.
const identity = () => (window as unknown as { google?: GoogleIdentityServices }).google

let loading: Promise<GoogleIdentityServices> | null = null

/** Loads Google Identity Services once; a failed load can be retried by calling again. */
export function loadGoogleIdentity(): Promise<GoogleIdentityServices> {
	const loaded = identity()
	if (loaded?.accounts?.id) return Promise.resolve(loaded)

	loading ??= new Promise<GoogleIdentityServices>((resolve, reject) => {
		const script = document.createElement('script')
		script.src = SCRIPT_SRC
		script.async = true
		script.onload = () => resolve(identity()!)
		script.onerror = () => {
			loading = null
			script.remove()
			reject(new Error('Unable to load Google Sign-In'))
		}
		document.head.appendChild(script)
	})
	return loading
}
